import { render, staticRenderFns } from "./NewMessageForm.vue?vue&type=template&id=787c2a88&scoped=true&"
import script from "./NewMessageForm.vue?vue&type=script&lang=js&"
export * from "./NewMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./NewMessageForm.vue?vue&type=style&index=0&id=787c2a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787c2a88",
  null
  
)

export default component.exports